<template>
  <nav class="bg-blue shadow fixed z-50 pin-b md:h-screen w-full transition-all" :class="sidebar">
    <div
      class="bg-blue-dark flex items-center justify-between bg-grey-lighter fixed md:relative pin-t md:pin-b pin-l w-full h-16 sm:h-24 py-3 px-3"
    >
      <sp-link :to="currentUser.role !== 'Investor' ? { name: 'home' } : ''" :class="logo_class" class="theme">
        <img :class="logoDetails.class" :alt="logoDetails.alt" :src="logoDetails.path" :title="logoDetails.alt" />
      </sp-link>
      <button
        class="sidebar-toggler items-center p-1 text-grey-light hover:text-white hidden md:flex"
        :class="menu_class"
        @click="toggle_sidebar"
      >
        <svg class="fill-current h-6 w-6" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <title>{{ $t("nav.menu") }}</title>
          <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
        </svg>
      </button>
    </div>

    <div class="content-center md:content-start text-left justify-between" id="content-nav">
      <ul :class="{'scrollable-nav': currentUser.role == 'form-builder'}" class="list-reset text-white flex flex-row md:flex-col text-center md:text-left md:mt-6">
        <li v-if="currentUser.role != 'Investor'" class="md:mb-2 flex-1">
          <sp-link :to="{ name: 'home' }" :class="href_class" class theme="nav">
            <i
              class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-white icon icon-home"
            ></i>
            <span
              class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
              :class="nav_class"
            >{{ $t("nav.home") }}</span>
          </sp-link>
        </li>
        <div v-if="(currentUser.role && !['sso', 'Investor'].includes(currentUser.role)) && session.startup_application && 'id' in session.startup_application && !isStartupEcosystem">
          <li
            class="md:mb-2 flex-1"
            :class="parent_class"
            v-if="this.ApplicationMenuActive == 1 && this.LabelMenuActive == 0 || showApp"
          >
            <a
              @click="toggle_children"
              :class="href_class + ' ' + active_class"
              class="no-underline cursor-pointer transition-all block py-3 md:py-3 align-middle md:whitespace-no-wrap border-b-4 md:border-b-0 md:border-l-7 transition-opacity hover:opacity-100 hover:border-red min-h-sm"
            >
              <i
                class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-white icon icon-condidature"
              ></i>
              <span
                class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
                :class="nav_class"
              >{{ $t("nav.application") }}</span>
            </a>
            <ul
              :class="children_class"
              class="bg-blue-dark absolute md:relative pin-tt pin-l zIndex-x w-full list-reset text-white text-center md:text-left transition-all"
              v-if="session.startup_application != null"
            >

              <li class="md:mb-2 flex-1">
                <sp-link
                  :to="{
                    name: 'FormCriteria',
                    params: { app_id: session.startup_application.id }
                  }"
                  :class="href2_class"
                  class
                  theme="nav"
                >
                  <i
                    class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-white text-xl sp-icon-pen-write"
                  ></i>
                  <span
                    class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
                    :class="nav_class"
                  >{{ $t("nav.criteria") }}</span>
                </sp-link>
              </li>
              <li class="md:mb-2 flex-1">
                <sp-link
                  :to="{
                    name: 'FormInnovations',
                    params: { app_id: session.startup_application.id }
                  }"
                  :class="href2_class"
                  class
                  theme="nav"
                >
                  <i
                    class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-white text-xl sp-icon-settings-user"
                  ></i>
                  <span
                    class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
                    :class="nav_class"
                  >{{ $t("nav.innovations") }}</span>
                </sp-link>
              </li>
              <!--<li class="md:mb-2 flex-1">
                <sp-link
                  :to="{
                    name: 'teams',
                    params: { app_id: session.startup_application.id }
                  }"
                  :class="href2_class"
                  class
                  theme="nav"
                  >
                    <i
                      class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-white text-xl sp-icon-multiple-users-wifi"
                    ></i>
                    <span
                      class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
                      :class="nav_class"
                    >{{ $t("nav.teams") }}</span>
                  </sp-link>
                </li>-->

              <li class="md:mb-2 flex-1">
                <sp-link
                  :to="{
                    name: 'team-edit',
                    params: {  app_id: session.startup_application.id, team_id: currentUser.id }
                  }"
                  :class="href2_class"
                  class
                  theme="nav"
                >
                  <i
                    class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-white text-xl sp-icon-messages-bubble-square-text"
                  ></i>
                  <span
                    class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
                    :class="nav_class"
                  >{{ $t("nav.infos") }}</span>
                </sp-link>
              </li>

              <li
                class="md:mb-2 flex-1"
                v-if="currentUser.role != 'sso' && session && session.user_auth && session.startup_application"
              >
                <sp-link
                  :to="{
                    name: 'FormChecklist',
                    params: { app_id: session.startup_application.id }
                  }"
                  :class="href2_class"
                  class
                  theme="nav"
                >
                  <i
                    class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-white text-xl sp-icon-checklist"
                  ></i>
                  <span
                    class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
                    :class="nav_class"
                  >{{ $t("nav.checklist") }}</span>
                </sp-link>
              </li>
              <li class="md:mb-2 flex-1">
                <sp-link :to="{ name: 'Status' }" :class="href2_class" class theme="nav">
                  <i
                    class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-white text-xl sp-icon-Group-14"
                  ></i>
                  <span
                    class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
                    :class="nav_class"
                  >{{ $t("nav.status") }}</span>
                </sp-link>
              </li>
            </ul>
          </li>
        </div>
        <div v-if="ecosystemMenu && ecosystemApp && ecosystemApp.application
          && (ecosystemApp.application.status != '9'
          || !ecosystemApp.application.declarationMenu
          || ecosystemApp.application.status == 9 && ecosystemApp.application.result == null
          || ecosystemApp.application.result != null && ecosystemApp.application.result.status != 2)">
          <a
            @click="toggle_children"
            :class="href_class + ' ' + active_class"
            class="no-underline cursor-pointer transition-all block py-3 md:py-3 align-middle md:whitespace-no-wrap border-b-4 md:border-b-0 md:border-l-7 transition-opacity hover:opacity-100 hover:border-red min-h-sm"
          >
            <i
              class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-white icon icon-condidature"
            ></i>
            <span
              class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
              :class="nav_class"
              v-if="currentUser.role == 'sso'"
            >
              <div v-if="ecosystemApp && ecosystemApp.application && ecosystemApp.application.type == 'Certif'">{{ $t("ecosystem.certif") }}</div>
              <div v-else>
                <div v-if="ecosystemApp.application.type == 'Sail' ">{{ $t("ecosystem.sail") }}</div>
                <div v-else>{{ $t("ecosystem.deal") }}</div>
              </div>
            </span>
            <span
              class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
              :class="nav_class"
              v-else
            >
              <fragment v-if="ecosystemApp && ecosystemApp.application && ecosystemApp.application.type == 'Air'">{{ $t("ecosystem.air") }}</fragment>
              <fragment v-else-if="ecosystemApp && ecosystemApp.application && ecosystemApp.application.type == 'Air2'">{{ $t("ecosystem.air2") }}</fragment>
              <fragment v-else-if="ecosystemApp && ecosystemApp.application && ecosystemApp.application.type == 'D4D'">{{ $t("ecosystem.d4d") }}</fragment>
              <!-- <fragment v-else-if="ecosystemApp && ecosystemApp.application && ecosystemApp.application.type == 'Investor'">{{ $t("ecosystem.investor") }}</fragment> -->
              <!-- <fragment v-else>{{ $t("ecosystem.investor_profile") }}</fragment> -->
            </span>
          </a>
          <ul
            :class="children_class"
            class="bg-blue-dark absolute md:relative pin-tt pin-l zIndex-x w-full list-reset text-white text-center md:text-left transition-all"
          >
            <li class="md:mb-2 flex-1" v-if="currentUser.role == 'sso' && ecosystemApp && ecosystemApp.application && ecosystemApp.application.type == 'Certif'">
              <sp-link
                :to="{
                  name: 'StructureAndOrganization',
                  params: {
                    formName: 'structure-and-organization',
                    ecoAppId: this.ecosystemApp.application.hash_id,
                    appType: this.ecosystemApp.application.type.toLowerCase()
                  }
                }"
                :class="href2_class"
                class
                theme="nav"
              >
                <i
                  class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-white text-xl sp-icon-pen-write"
                ></i>
                <span
                  class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
                  :class="nav_class"
                >{{ $t("ecosystem.structure_and_organization") }}</span>
              </sp-link>
            </li>
            <li class="md:mb-2 flex-1" v-if="currentUser.role == 'sso' && ecosystemApp && ecosystemApp.application && ecosystemApp.application.type == 'Certif'">
              <sp-link
                :to="{
                  name: 'AnteriorPrograms',
                  params: {
                    formName: 'anterior-programs',
                    ecoAppId: this.ecosystemApp.application.hash_id,
                    appType: this.ecosystemApp.application.type.toLowerCase()
                  }
                }"
                :class="href2_class"
                class
                theme="nav"
              >
                <i
                  class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-white text-xl sp-icon-pen-write"
                ></i>
                <span
                  class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
                  :class="nav_class"
                >{{ $t("ecosystem.anterior_programs") }}</span>
              </sp-link>
            </li>
            <li class="md:mb-2 flex-1" v-if="currentUser.role == 'sso' && ecosystemApp && ecosystemApp.application && ecosystemApp.application.type == 'Deal'">
              <sp-link
                :to="{
                  name: 'DealForm',
                  params: {
                    formName: 'deal-form',
                    ecoAppId: this.ecosystemApp.application.hash_id,
                    appType: this.ecosystemApp.application.type.toLowerCase()
                  }
                }"
                :class="href2_class"
                class
                theme="nav"
              >
                <i
                  class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-white text-xl sp-icon-pen-write"
                ></i>
                <span
                  class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
                  :class="nav_class"
                >{{ $t("ecosystem.deal_form") }}</span>
              </sp-link>
            </li>
            <li class="md:mb-2 flex-1" v-if="currentUser.role == 'sso' && ecosystemApp && ecosystemApp.application && ecosystemApp.application.type == 'Sail'">
              <sp-link
                :to="{
                  name: 'SailForm',
                  params: {
                    formName: 'sail-form',
                    ecoAppId: this.ecosystemApp.application.hash_id,
                    appType: this.ecosystemApp.application.type.toLowerCase()
                  }
                }"
                :class="href2_class"
                class
                theme="nav"
              >
                <i
                  class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-white text-xl sp-icon-pen-write"
                ></i>
                <span
                  class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
                  :class="nav_class"
                >{{ $t("ecosystem.sail_form") }}</span>
              </sp-link>
            </li>

            <li class="md:mb-2 flex-1" v-if="currentUser.role == 'sso' && ecosystemApp && ecosystemApp.application && !['Deal','Sail'].includes(ecosystemApp.application.type)">
              <sp-link
                :to="{
                  name: 'EcoTeam',
                  params: { app_id: this.ecosystemApp.application.hash_id }
                }"
                :class="href2_class"
                class
                theme="nav"
              >
                <i
                  class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-white text-xl sp-icon-multiple-users-wifi"
                ></i>
                <span
                  class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
                  :class="nav_class"
                >{{ $t("nav.teams") }}</span>
              </sp-link>
            </li>
            <li class="md:mb-2 flex-1" v-if="currentUser.role == 'sso' && ecosystemApp && ecosystemApp.application && !['Deal','Sail'].includes(ecosystemApp.application.type)">
              <sp-link
                :to="{
                  name: 'team-edit',
                  params: {  app_id: this.ecosystemApp.application.hash_id, team_id: currentUser.id }
                }"
                :class="href2_class"
                class
                theme="nav"
              >
                <i
                  class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-white text-xl sp-icon-messages-bubble-square-text"
                ></i>
                <span
                  class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
                  :class="nav_class"
                >{{ $t("nav.infos") }}</span>
              </sp-link>
            </li>

            <li class="md:mb-2 flex-1" v-if="currentUser.role == 'Startup' && ecosystemApp && ecosystemApp.application && ecosystemApp.application.type == 'Air'">
              <sp-link
                :to="{
                  name: 'GeneralInfosAir',
                  params: {
                    formName: 'general-infos-air',
                    ecoAppId: this.ecosystemApp.application.hash_id || this.ecosystemApp.application.id,
                    appType: this.ecosystemApp.application.type.toLowerCase()
                  }
                }"
                :class="href2_class"
                class
                theme="nav"
              >
                <i
                  class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-white text-xl sp-icon-messages-bubble-square-text"
                ></i>
                <span
                  class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
                  :class="nav_class"
                >{{ $t("ecosystem.general_infos") }}</span>
              </sp-link>
            </li>

            <!-- Add General info D4D nav menu -->
            <li class="md:mb-2 flex-1" v-if="currentUser.role == 'Startup' && ecosystemApp && ecosystemApp.application && ecosystemApp.application.type == 'D4D'">
              <sp-link
                :to="{
                  name: 'GeneralInfosD4d',
                  params: {
                    formName: 'general-infos-d4d',
                    ecoAppId: this.ecosystemApp.application.hash_id || this.ecosystemApp.application.id,
                    appType: this.ecosystemApp.application.type.toLowerCase()
                  }
                }"
                :class="href2_class"
                class
                theme="nav"
              >
                <i
                  class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-white text-xl sp-icon-messages-bubble-square-text"
                ></i>
                <span
                  class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
                  :class="nav_class"
                >{{ $t("ecosystem.general_infos") }}</span>
              </sp-link>
            </li>

            <!-- Add Funding requirements D4D nav menu -->
            <li class="md:mb-2 flex-1" v-if="currentUser.role == 'Startup' && ecosystemApp && ecosystemApp.application && ecosystemApp.application.type == 'D4D'">
              <sp-link
                :to="{
                  name: 'FundingRequirements',
                  params: {
                    formName: 'funding-requirements',
                    ecoAppId: this.ecosystemApp.application.hash_id || this.ecosystemApp.application.id,
                    appType: this.ecosystemApp.application.type.toLowerCase()
                  }
                }"
                :class="href2_class"
                class
                theme="nav"
              >
                <i
                  class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-white text-xl sp-icon-messages-bubble-square-text"
                ></i>
                <span
                  class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
                  :class="nav_class"
                >{{ $t("ecosystem.funding_requirements") }}</span>
              </sp-link>
            </li>
            <li class="md:mb-2 flex-1" v-if="currentUser.role == 'Startup' && ecosystemApp && ecosystemApp.application && ecosystemApp.application.type == 'Air'">
              <sp-link
                :to="{
                  name: 'Air',
                  params: {
                    formName: 'air',
                    ecoAppId: this.ecosystemApp.application.hash_id || this.ecosystemApp.application.id,
                    appType: this.ecosystemApp.application.type.toLowerCase()
                  }
                }"
                :class="href2_class"
                class
                theme="nav"
              >
                <i
                  class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-white text-xl sp-icon-messages-bubble-square-text"
                ></i>
                <span
                  class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
                  :class="nav_class"
                >{{ $t("ecosystem.air") }}</span>
              </sp-link>
            </li>
            <li class="md:mb-2 flex-1" v-if="currentUser.role == 'Startup' && ecosystemApp && ecosystemApp.application && ecosystemApp.application.type == 'Air2'">
              <sp-link
                :to="{
                  name: 'GeneralInfosAir2',
                  params: {
                    formName: 'general-infos-air2',
                    ecoAppId: this.ecosystemApp.application.hash_id || this.ecosystemApp.application.id,
                    appType: this.ecosystemApp.application.type.toLowerCase()
                  }
                }"
                :class="href2_class"
                class
                theme="nav"
              >
                <i
                  class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-white text-xl sp-icon-messages-bubble-square-text"
                ></i>
                <span
                  class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
                  :class="nav_class"
                >{{ $t("ecosystem.general_infos") }}</span>
              </sp-link>
            </li>
            <li class="md:mb-2 flex-1" v-if="currentUser.role == 'Startup' && ecosystemApp && ecosystemApp.application && ecosystemApp.application.type == 'Air2'">
              <sp-link
                :to="{
                  name: 'Air2',
                  params: {
                    formName: 'air2',
                    ecoAppId: this.ecosystemApp.application.hash_id || this.ecosystemApp.application.id,
                    appType: this.ecosystemApp.application.type.toLowerCase()
                  }
                }"
                :class="href2_class"
                class
                theme="nav"
              >
                <i
                  class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-white text-xl sp-icon-messages-bubble-square-text"
                ></i>
                <span
                  class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
                  :class="nav_class"
                >{{ $t("ecosystem.air2") }}</span>
              </sp-link>
            </li>
            <li class="md:mb-2 flex-1" v-if="currentUser.role == 'Startup' && ecosystemApp && ecosystemApp.application && ['Air', 'Air2', 'D4D'].includes(ecosystemApp.application.type)">
              <sp-link
                :to="{
                  name: 'EcoTeam',
                  params: { app_id: this.ecosystemApp.application.hash_id || this.ecosystemApp.application.id }
                }"
                :class="href2_class"
                class
                theme="nav"
              >
                <i
                  class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-white text-xl sp-icon-multiple-users-wifi"
                ></i>
                <span
                  class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
                  :class="nav_class"
                >{{ $t("nav.teams") }}</span>
              </sp-link>
            </li>
            <!-- <li class="md:mb-2 flex-1" v-if="currentUser.role == 'Investor' && ecosystemApp && ecosystemApp.application && ecosystemApp.application.type == 'Investor'">
              <sp-link
                :to="{
                  name: 'InvestorFormPrincipal',
                  params: {
                    ecoAppId: this.ecosystemApp.application.hash_id || this.ecosystemApp.application.id
                  }
                }"
                :class="href2_class"
                class
                theme="nav"
              >
                <i
                  class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-white text-xl sp-icon-messages-bubble-square-text"
                ></i>
                <span
                  class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
                  :class="nav_class"
                >{{ $t("nav.profile") }}</span>
              </sp-link>
            </li>
            <li v-if="currentUser.role == 'Investor' && ecosystemApp && ecosystemApp.application && ecosystemApp.application.type == 'Investor'" class="md:mb-2 flex-1">
              <sp-link
                :to="{ name: 'sessionlessDeclaration',
                  params: {
                    app_id: this.ecosystemApp.application.hash_id,
                    appType: this.ecosystemApp.application.type.toLowerCase()
                  }
                }"
                :class="href2_class"
                theme="nav"
              >
                <i
                  class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-xl text-white icon icon-avantage"
                ></i>
                <span
                  class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
                  :class="nav_class"
                >{{ $t("nav.declarations") }}</span>
              </sp-link>
            </li>
            <li class="md:mb-2 flex-1" v-if="currentUser.role == 'Investor' && ecosystemApp && ecosystemApp.application && ecosystemApp.application.type == 'Investor'">
              <sp-link
                :to="{
                  name: 'InvestorCertificate',
                  params: {
                    ecoAppId: this.ecosystemApp.application.hash_id || this.ecosystemApp.application.id
                  }
                }"
                :class="href2_class"
                class
                theme="nav"
              >
                <i
                  class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-white text-xl sp-icon-Group-14"
                ></i>
                <span
                  class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
                  :class="nav_class"
                >{{ $t("ecosystem.certificate") }}</span>
              </sp-link>
            </li> -->
            <li class="md:mb-2 flex-1" v-if="currentUser.role == 'Startup' && ecosystemApp && ecosystemApp.application && ['Air', 'Air2', 'D4D'].includes(ecosystemApp.application.type)">
              <sp-link
                :to="{
                  name: 'team-edit',
                  params: {  app_id: this.ecosystemApp.application.hash_id || this.ecosystemApp.application.id, team_id: currentUser.id }
                }"
                :class="href2_class"
                class
                theme="nav"
              >
                <i
                  class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-white text-xl sp-icon-messages-bubble-square-text"
                ></i>
                <span
                  class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
                  :class="nav_class"
                >{{ $t("nav.infos") }}</span>
              </sp-link>
            </li>
            <li
              class="md:mb-2 flex-1"
              v-if="
                ecosystemApp &&
                ecosystemApp.application &&
                currentUser &&
                ecosystemApp.application.user_id == currentUser.id &&
                currentUser.role != 'Investor'
              "
            >
              <sp-link
                :to="{
                  name: 'FormChecklist',
                  params: { app_id: this.ecosystemApp.application.hash_id || this.ecosystemApp.application.id }
                }"
                :class="href2_class"
                class
                theme="nav"
              >
                <i
                  class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-white text-xl sp-icon-checklist"
                ></i>
                <span
                  class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
                  :class="nav_class"
                >{{ $t("nav.checklist") }}</span>
              </sp-link>
            </li>
            <li class="md:mb-2 flex-1" v-if="currentUser && currentUser.role != 'Investor'">
              <sp-link :to="{ name: 'Status', params: { app_id: this.ecosystemApp.application.hash_id || this.ecosystemApp.application.id } }" :class="href2_class" class theme="nav">
                <i
                  class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-white text-xl sp-icon-Group-14"
                ></i>
                <span
                  class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
                  :class="nav_class"
                >{{ $t("nav.status") }}</span>
              </sp-link>
            </li>
          </ul>
        </div>
        <div v-if="currentUser.role != 'Investor' && ecosystemMenu && ecosystemApp && ecosystemApp.application && ecosystemApp.application.status == '9' && ecosystemApp.application.result != null && this.ecosystemApp.application.result.status == 2 && (isStartupEcosystem || (currentUser && currentUser.role === 'sso') && ecosystemApp.application.declarationMenu)">
          <ul
            class="list-reset text-white flex flex-row md:flex-col text-center md:text-left"
          >
            <li class="md:mb-2 flex-1">
              <sp-link
                :to="{ name: 'Declarations',
                  params: {
                    app_id: this.ecosystemApp.application.hash_id,
                    appType: this.ecosystemApp.application.type.toLowerCase()
                  }
                }"
                :class="href_class + ' ' + active_class"
                theme="nav"
              >
                <i
                  class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-xl text-white icon icon-avantage"
                ></i>
                <span
                  class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
                  :class="nav_class"
                >{{ $t("nav.declarations") }}</span>
              </sp-link>
            </li>
          </ul>
        </div>
        <li
          class="md:mb-2 flex-1"
          v-if="
            currentUser.role != 'Investor' &&
            (session.startup_application &&
              'status' in session.startup_application) &&
              this.LabelMenuActive == 1 &&
              !isStartupEcosystem &&
              (session.startup_application.status == 9 ||
                session.startup_application.status == 12)
          "
        >
          <sp-link
            :to="{
              name: 'Label',
              params: { app_id: this.hashId }
            }"
            :class="href_class"
            class
            theme="nav"
          >
            <i
              class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-xl text-white sp-icon-messages-bubble-square-text"
            ></i>
            <span
              class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
              :class="nav_class"
            >{{ $t("nav.label") }}</span>
          </sp-link>
        </li>
        <li
          class="md:mb-2 flex-1"
          v-if="
            (session && session.startup_application &&
              'status' in session.startup_application) &&
              this.LabelMenuActive == 1 &&
              this.LabelApplication != null &&
              session.startup_application.user_id == session.user_auth.id &&
              session.startup_application.label_created_at != null &&
              session.startup_application.status != 12 &&
              !isStartupEcosystem
          "
        >
          <sp-link
            :to="{
                      name: 'Entreprise',
                      params: { app_id: this.hashId }
                    }"
            :class="href_class"
            class
            theme="nav"
          >
            <i
              class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-xl text-white icon icon-company"
            ></i>
            <span
              class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
              :class="nav_class"
            >{{ $t("nav.entreprise") }}</span>
          </sp-link>
        </li>
        <li
          class="md:mb-2 flex-1"
          v-if="
            (session && session.startup_application &&
              'status' in session.startup_application) &&
              this.LabelMenuActive == 1 &&
              this.LabelApplication != null &&
              session.startup_application.user_id == session.user_auth.id &&
              session.startup_application.label_created_at != null &&
              session.startup_application.status == '9' &&
              !isStartupEcosystem
          "
        >
          <sp-link
             :to="{
                  name: 'StartupInformationsForm',
                  params: { app_id: session.startup_application.id }
                }"
            :class="href_class"
            class
            theme="nav"
          >
            <i
              class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-xl text-white icon icon-avantage"
            ></i>
            <span
              class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
              :class="nav_class"
            >{{ $t("nav.startup_informations") }}</span>
          </sp-link>
        </li>
        <li
          class="md:mb-2 flex-1"
          v-if="
            currentUser.role != 'Investor' &&
            (session.startup_application &&
              'status' in session.startup_application) &&
              this.LabelMenuActive == 1 &&
              this.LabelApplication != null &&
              session.startup_application.label_created_at != null &&
              session.startup_application.status != 12 &&
              !isStartupEcosystem
          "
        >
          <sp-link
            :to="{ name: 'Declarations',
              params: {
                app_id: this.hashId,
                appType: session.startup_application.type.toLowerCase()
              }
            }"
            :class="href_class"
            class
            theme="nav"
          >
            <i
              class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-xl text-white icon icon-statement"
            ></i>
            <span
              class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
              :class="nav_class"
            >{{ $t("nav.declarations") }}</span>
          </sp-link>
        </li>
        <li
          class="md:mb-2 flex-1"
          v-if="
            currentUser.role != 'Investor' &&
            (session.startup_application &&
              'status' in session.startup_application) &&
              this.LabelMenuActive == 1 &&
              this.LabelApplication != null &&
              session.startup_application.label_created_at != null &&
              session.startup_application.status != 12 &&
              !isStartupEcosystem
          "
        >
          <sp-link
            :to="{
                    name: 'Avantages',
                    params: { app_id: this.hashId }
                  }"
            :class="href_class"
            class
            theme="nav"
          >
            <i
              class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-xl text-white icon icon-avantage"
            ></i>
            <span
              class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
              :class="nav_class"
            >{{ $t("nav.avantages") }}</span>
          </sp-link>
        </li>
        <!-- <li
          class="md:mb-2 flex-1"
          v-if="
            currentUser.role != 'Investor' &&
            (session.startup_application &&
              'status' in session.startup_application) &&
              this.LabelMenuActive == 1 &&
              this.LabelApplication != null &&
              session.startup_application.label_created_at != null &&
              session.startup_application.status != 12 &&
              !isStartupEcosystem
          "
        >
          <sp-link
            :to="{
                    name: 'Financement',
                    params: { app_id: this.hashId }
                  }"
            :class="href_class"
            class
            theme="nav"
          >
            <i
              class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-xl text-white icon icon-funding"
            ></i>
            <span
              class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
              :class="nav_class"
            >{{ $t("nav.financement") }}</span>
          </sp-link>
        </li>
        <li
          class="md:mb-2 flex-1"
          v-if="
            (session.startup_application &&
              'status' in session.startup_application) &&
              showFormBuilderTest
          "
        >
          <sp-link
            :to="{
                    name: 'FormBuilderTest',
                    params: {
                      ref: this.session.startup_application.label_ref,
                      type_id: 20
                    }
                  }"
            :class="href_class"
            class
            theme="nav"
          >
            <i
              class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-xl text-white icon icon-funding"
            ></i>
            <span
              class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
              :class="nav_class"
            >Form Builder Test</span>
          </sp-link>
        </li> -->
        <li class="md:mb-2 flex-1 bg-blue" id="support_nav">
          <a
            :href="mail_support"
            :class="href_class"
            class="no-underline cursor-pointer transition-all block py-3 md:py-3 align-middle md:whitespace-no-wrap opacity-40 border-b-4 md:border-b-0 md:border-l-7 transition-opacity hover:opacity-100 hover:border-red min-h-sm md:pl-3"
            theme="nav"
          >
            <i
              class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-white icon icon-support"
            ></i>
            <span
              class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
              :class="nav_class"
            >{{ $t("nav.support") }}</span>
          </a>
        </li>
        <div v-if="builderForms">
          <li class="md:mb-2 flex-1 bg-blue" v-for="(form, index) in builderForms" :key="index">
            <sp-link :to="{ name: 'BuilderForm', params: {id: form.id} }" :class="href_class" class theme="nav">
              <span
                class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
                :class="nav_class"
              >{{ form.name }}</span>
            </sp-link>
          </li>
        </div>
        <li v-if="currentUser.role != 'Investor'" class="w-full md:mb-2 flex-1 relative md:absolute pin-b pin-l bg-blue" id="logout">
          <sp-link :to="{ name: 'logout' }" :class="href_class" class theme="nav">
            <i
              class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-white text-xl sp-icon-logout-2"
            ></i>
            <span
              class="hidden md:inline-block pb-1 md:pb-0 text-sm md:text-2sm text-white leading-loose transition-all"
              :class="nav_class"
            >{{ $t("nav.logout") }}</span>
          </sp-link>
        </li>
      </ul>
    </div>
  </nav>
</template>
<style>
.dynamic-width:hover {
  width: fit-content!important;
}
.scrollable-nav {
  overflow: scroll;
  height: 1000px;
}
.icon::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 4px;
  left: 0;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}
.icon.icon-home::before {
  background-image: url("../assets/img/home.svg");
}
.icon.icon-condidature::before {
  background-image: url("../assets/img/condidature.svg");
}
.icon.icon-support::before {
  background-image: url("../assets/img/support.svg");
}
.icon.icon-logout::before {
  background-image: url("../assets/img/logout.png");
}
.icon.icon-avantage::before {
  background-image: url("../assets/img/avantage.svg");
}
.icon.icon-company::before {
  background-image: url("../assets/img/company.svg");
}
.icon.icon-statement::before {
  background-image: url("../assets/img/statement.svg");
}
.icon.icon-funding::before {
  background-image: url("../assets/img/accounting-coins-bill.svg");
}
.page-sidebar-closed {
  width: 150px;
}
#support_nav {
  margin-bottom: 4rem;
}

@media (max-width: 768px) {
  .pin-tt {
    bottom: 0;
  }

  nav li.bg-blue-dark .pin-tt {
    bottom: 100%;
  }

  #support_nav {
    margin-bottom: 0rem;
  }
}

@media (max-height: 720px) and (min-width: 768px) {
  #logout {
    position: relative !important;
  }
  #content-nav {
    height: calc(100vh - 96px);
    overflow-x: auto;
  }
  #support_nav {
    margin-bottom: 0rem;
  }
}

.width-11 {
  width: 11rem;
}
</style>

<script>
import { mapGetters } from "vuex";
import { LOGOUT, GET_BUILDER_FORMS, FETCH_ECOSYSTEM_APPLICATION, FETCH_APPLICATION, GET_INVESTOR_DECLARATION } from "@/store/actions.type";
import { SET_SidebarActive, SET_SHOW_APP, SET_ECOSYSTEM_MENU_ACTIVE, SET_ECOSYSTEM_APP } from "@/store/mutations.type";
import Link from "@/components/spKit/Link.vue";
import { MAIL_SUPPORT } from "@/common/config";
import { Fragment } from "vue-fragment";
export default {
  name: "Navbar",
  components: {
    "sp-link": Link,
    "fragment": Fragment
  },
  data() {
    return {
      langs: ["fr", "en"],
      sidebar: "",
      logo_class: "",
      nav_class: "block md:inline-block",
      href_class: "md:pl-3",
      href2_class: "md:pl-5",
      menu_class: "",
      sidebarActive: 1,
      children_class: "hidden",
      parent_class: "bg-blue",
      active_class: "opacity-40",
      childrenActive: false,
      routerNoApplication: [
        "home",
        "Label",
        "requestFrom",
        "Avantages",
        "Entreprise",
        "StartupInformationsForm",
        "Financement"
      ],
      mail_support: "mailto:" + MAIL_SUPPORT + "?Subject=Support%20Startupact",
      builderForms: null,
      logoDetails: {
        path: require("../assets/img/logo-CQE.png"),
        alt: "Startup Tunisia Logo",
        class: "width-11"
      }
    };
  },
  computed: {
    ...mapGetters([
      "session",
      "currentUser",
      "isAuthenticated",
      "ApplicationMenuActive",
      "LabelMenuActive",
      "hashId",
      "LabelApplication",
      "ecosystemMenu",
      "ecosystemApp",
      "showApp",
      "StartupInformations"
    ]),
    showFormBuilderTest() {
      return location.hostname == "localhost" ||
        location.hostname == "my.startupact.satoripop.tn" ||
        location.hostname == "startupact-mo-int.k8s.satoripop.io" ||
        location.hostname == "startupact-mo-test.k8s.satoripop.io"
        ? true
        : false;
    },
    isStartupEcosystem() {
      let startupEco = false;
      let hashId = this.$route.params.app_id || this.$route.params.ref;
      if (hashId) {
        if (
          this.ecosystemApp &&
          this.ecosystemApp.application &&
          ["Air", "Air2", "D4D"].includes(this.ecosystemApp.application.type) &&
          this.ecosystemApp.application.id == hashId
        ) {
          startupEco = true;
        }
      }

      return startupEco;
    }
  },
  methods: {
    changeLocale() {
      window.localStorage.setItem("lang", this.$i18n.locale);
    },
    logout() {
      this.$store.dispatch(LOGOUT).then(() => {
        this.$router.push({ name: "home" });
      });
    },
    toggle_sidebar() {
      if (this.sidebarActive == 1) this.sidebarActive = 0;
      else this.sidebarActive = 1;
    },
    toggle_children() {
      if (this.childrenActive == true) this.childrenActive = false;
      else this.childrenActive = true;
    },
    getBuilderForms() {
      this.$store
        .dispatch(GET_BUILDER_FORMS)
        .then(data => {
          this.sidebar += ' dynamic-width';
          this.builderForms = data.data.forms;
        });
    }
  },
  watch: {
    sidebarActive() {
      window.localStorage.setItem("sidebar_closed", this.sidebarActive);
      if (this.sidebarActive == 1) {
        this.sidebar = "md:w-22";
        this.logo_class = "md:hidden";
        this.menu_class = "mx-auto";
        this.nav_class = "md:hidden";
        this.href_class = "md:pl-6";
        this.href2_class = "md:pl-6";
      } else {
        this.sidebar = "md:w-60";
        this.logo_class = "";
        this.menu_class = "";
        this.nav_class = "";
        this.href_class = "md:pl-3";
        this.href2_class = "md:pl-5";
      }
      this.$store.commit(SET_SidebarActive, this.sidebarActive);
    },
    childrenActive() {
      if (this.childrenActive == true) {
        this.children_class = "flex flex-row md:flex-col";
        this.parent_class = "bg-blue-dark";
        this.active_class = "opacity-100 border-red";
      } else {
        this.children_class = "hidden";
        this.parent_class = "bg-blue";
        this.active_class = "opacity-40";
      }
    },
    $route() {
      this.childrenActive = !this.routerNoApplication.includes(
        this.$route.name
      );
    },
    currentUser() {
      if (this.currentUser.role == 'form-builder') {
        this.getBuilderForms();
      }
    }
  },
  mounted() {
    if (this.currentUser.role == 'form-builder') {
      this.getBuilderForms();
    }
    if(this.session.startup_application == null){
       //this.$router.push({ name: "home" });
    }
    this.sidebarActive = window.localStorage.getItem("sidebar_closed");
    if (this.sidebarActive == 1) {
      this.sidebar = "md:w-22";
      this.logo_class = "md:hidden";
      this.menu_class = "mx-auto";
      this.nav_class = "md:hidden";
      this.href_class = "pl-6";
      this.href2_class = "pl-6";
    } else {
      this.sidebar = "md:w-60";
      this.logo_class = "";
      this.menu_class = "";
      this.nav_class = "";
      this.href_class = "md:pl-3";
      this.href2_class = "md:pl-5";
    }
    this.childrenActive = !this.routerNoApplication.includes(this.$route.name);
    if (this.currentUser.role == 'Investor') {
      let hashId = this.$route.params.app_id || this.$route.params.ecoAppId;
      const ecosystemAppId = (typeof hashId !== "undefined") ? hashId : this.ecosystemApp.application.hash_id;
      this.$store.dispatch(FETCH_ECOSYSTEM_APPLICATION, ecosystemAppId);
    }
  },

  created() {
    let hashId = this.$route.params.app_id || this.$route.params.ecoAppId;
    if (hashId) {
      if (this.$route.params.appType && this.$route.params.appType != 'certif' && this.$route.params.appType != 'deal' && this.$route.params.appType != 'sail') {
        /* Scenario is only for Air, Air2 and D4D
        * we fetch for application type first, if it's in array ["Air", "Air2", "D4D"] then
        * fetch ecosystem app
        * This work is for team members, to show appropriate app navigations
        */
        if (this.currentUser.role != 'Investor') {
          this.$store.dispatch(FETCH_APPLICATION, hashId).then((data) => {
            if (data.data.startup_application) {
              if (["Air", "Air2", "D4D"].includes(data.data.startup_application.type)) {
                this.$store
                  .dispatch(FETCH_ECOSYSTEM_APPLICATION, hashId);
              }
            }
          });
        }
      }

      if (this.currentUser.role == 'Investor') {
        this.$store
            .dispatch(GET_INVESTOR_DECLARATION, hashId)
            .then(response => {
              this.$store.commit(SET_ECOSYSTEM_MENU_ACTIVE, true);
              this.$store.commit(SET_ECOSYSTEM_APP, response.data);
            });
      }
    }
  },
  beforeDestroy() {
    if (
      this.showApp &&
      ![
        "FormCriteria",
        "FormInnovations",
        "teams",
        "team-edit",
        "FormChecklist",
        "Status"
      ].includes(this.$route.name)
    ) {
      this.$store.commit(SET_SHOW_APP, false);
    }
  }
};
</script>
